<template>
  <section class="section-container">
    <div class="application">
        <v-container style="position:relative" class="mb-8">
        <v-row>
          <v-col cols="12" sm="6">
            <v-hover v-slot:default="{ hover }" open-delay="200">
              <v-btn style="background: transparent; box-shadow: none;color: #ada3f5;"
                class="ma-2 white--dark"
                right
                absolute
                @click="logout()"
              >
                <v-icon color="#212945">mdi-logout</v-icon>
                <v-expand-x-transition>
                  <span v-if="hover" class="ml-2"></span>
                </v-expand-x-transition>
                <span class="ml-2" style="color: #000000;text-transform: capitalize">Logout</span>
              </v-btn>
            </v-hover>
          </v-col>
        </v-row>
      </v-container>

      <v-container class="pa-10">
        <!-- <h1 style="color: #434343" class="text-center my-2">
          On Boarding Application Form
        </h1> -->
        <v-stepper v-model="index">
          <h3 class="" style="font-size:20px; text-align: center;">OnBoarding Application Form
            <!-- {{this.$store.state.stepperIndex}} -->
          </h3>
          <v-stepper-header>
            <v-stepper-step
              :complete="index > 1"
              step="1"
              :rules="[() => this.corporateInfoError]"
              color="#434343"
            >
              Corporate Information
            </v-stepper-step>

            <v-stepper-step
              :complete="index > 2"
              step="2"
              :rules="[() => this.contactInfoError]"
              color="#434343"
            >
              Contact Details
            </v-stepper-step>
            
            <v-stepper-step
              :complete="index > 3"
              step="3"
              :rules="[() => this.directorInfoError]"
              color="#434343"
            >
              Director Details
            </v-stepper-step>
            <v-stepper-step
              :complete="index > 4"
              step="4"
              :rules="[() => this.shareholderInfoError]"
              color="#434343"
            >
              shareholders Details
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              :complete="index > 5"
              :rules="[() => this.businessProfileError]"
              step="5"
              color="#434343"
            >
              Business Profile
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              step="6"
              :complete="index > 6"
              :rules="[() => this.transactionalProfileError]"
              color="#434343"
            >
              Transactional Profile
            </v-stepper-step>
            <!-- <v-divider></v-divider> -->
            <!-- <v-stepper-step
              step="4"
              :complete="index > 4"
              :rules="[() => this.websiteDetailsError]"
              color="#434343"
            >
              Website Details
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              step="5"
              :rules="[() => this.paymentInstructionsError]"
              :complete="index > 5"
              color="#434343"
            >
              Payments Instructions
            </v-stepper-step> -->
            <v-divider></v-divider>
            <v-stepper-step
              step="7"
              :complete="index > 7"
              color="#434343"
            >
              Supported Documents
            </v-stepper-step>
          </v-stepper-header>
          <!-- this stepper holds the form for corporate information  -->
          <v-stepper-items>
            <v-stepper-content step="1">
              <CorporateInfo />
            </v-stepper-content>
          
          <!-- contact info  -->
            <v-stepper-content step="2">
              <ContactInfo />
            </v-stepper-content>
     <!-- Director info  -->
            <v-stepper-content step="3">
              <DirectorInfo />
            </v-stepper-content>
            <!-- share holder info  -->
            <v-stepper-content step="4">
              <ShareHolderInfo />
            </v-stepper-content>
            <!-- this stepper holds information for BusinessProfileComponent  -->
            <v-stepper-content step="5">
              <business-component />
            </v-stepper-content>

            <!-- this stepper holds information for TransactionalProfileComponent  -->
            <v-stepper-content step="6">
              <transactional-profile-component />
            </v-stepper-content>
            <!-- this stepper holds information for WebsiteDetailsComponent  -->
            <v-stepper-content step="43">
              <website-details />
            </v-stepper-content>
            <!-- this stepper holds information for PaymentInstructionsComponent  -->
            <v-stepper-content step="53">
              <payment-profile />
            </v-stepper-content>
            <!-- this stepper holds information for Supported DocumentsComponent  -->
            <v-stepper-content step="7">
              <SupportedDoc />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import corporateComponent from "../components/CorporateInfoComponent.vue";
import businessComponent from "../components/BusinessProfileComponent.vue";
import TransactionalProfileComponent from "../components/TransactionalProfileComponent.vue";
import PaymentProfile from "../components/PaymentInstructionsComponent.vue";
import WebsiteDetails from "../components/WebsiteDetailsComponent.vue";
import SupportedDoc from "@/views/SupportedDoc";
import ContactInfo from "../components/ContactDetails.vue"
import DirectorInfo from "../components/DirectorDetails.vue"
import ShareHolderInfo from "../components/ShareHolderDetail.vue"
import CorporateInfo from "../components/CorporateDetails.vue"

export default {
  name: "application",
  components: {
    corporateComponent,
    businessComponent,
    TransactionalProfileComponent,
    PaymentProfile,
    WebsiteDetails,
    CorporateInfo,
    ContactInfo,
    DirectorInfo,
    ShareHolderInfo,
    SupportedDoc,
  },

  data() {
    return {
      val: true,
      elem: "",
      ele: "",
    };
  },
  computed: {
    index: function () {
      return this.$store.state.stepperIndex;
    },
    ...mapGetters([
      "getCorporateInfoError",
      "getPrimaryContactError",
      "getDirectorsDetailsError",
      "getShareholdersDetailsError",
      "getBusinessProfileError",
      "getWebsiteDetailsError",
      "getWebsiteContentError",
      "getPaymentInstructionsError",
      "getTransactionalProfileError",
    ]),
    corporateInfoError: function () {
      if (
        this.getCorporateInfoError
      ) {
        return !true;
      } else {
        return true;
      }
    },
    contactInfoError: function () {
      if (
        this.getPrimaryContactError
      ) {
        return !true;
      } else {
        return true;
      }
    },
    directorInfoError: function () {
      if (
        this.getDirectorsDetailsError
      ) {
        return !true;
      } else {
        return true;
      }
    },
    shareholderInfoError: function () {
      if (
        this.getShareholdersDetailsError
      ) {
        return !true;
      } else {
        return true;
      }
    },
    businessProfileError: function () {
      if (this.getBusinessProfileError) {
        return !true;
      } else {
        return true;
      }
    },
    websiteDetailsError: function () {
      if (this.getWebsiteDetailsError || this.getWebsiteContentError) {
        return !true;
      } else {
        return true;
      }
    },
    paymentInstructionsError: function () {
      if (this.getPaymentInstructionsError) {
        return !true;
      } else {
        return true;
      }
    },
    transactionalProfileError: function () {
      if (this.getTransactionalProfileError) {
        return !true;
      } else {
        return true;
      }
    },
  },
  methods: {
    updateIndex(index) {
      this.$store.dispatch("updateIndex", index);
    },
     logout(){
      var user_id ="";
      this.$store.dispatch("updateUserId", user_id);
      localStorage.removeItem("token");
      this.$store.dispatch("resetStore");
      this.$router.push({name:'signin'});
    }
  },
};
</script>
<style scoped>
@import url("../assets/css/style.css");
</style>
